import { Button } from '@/components/ui/daisy';
import { useToggleGroupContext } from '@/components/ui/daisy/toggle-group';
import { twMerge } from 'tailwind-merge';
import { QuizOption } from '@/components/question/view/typologies/quiz/useQuizAnswerView';
import { QuizAnswerContent } from '@/components/question/view/primitives/shared/QuizAnswerContent';

type QuizAnswerOptionProps = {
  option: QuizOption;
  disabled: boolean;
};

export function QuizAnswerOption({ option, disabled }: QuizAnswerOptionProps) {
  const { onItemClick } = useToggleGroupContext();
  const { id, answer, index, isSelected } = option;

  return (
    <Button
      type="button"
      color="secondary"
      variant={isSelected ? 'default' : 'outline'}
      size="lg"
      shape="block"
      aria-pressed={isSelected}
      onClick={() => onItemClick(String(id))}
      className={twMerge(
        'justify-start h-fit py-2',
        disabled &&
          'hover:bg-transparent hover:text-secondary hover:border-secondary hover:shadow-none',
      )}
    >
      <QuizAnswerContent answer={answer} index={index} />
    </Button>
  );
}
